import React, { useState } from "react";
import { Award } from "lucide-react";
import PathwayItemDetailsModal from "./PathwayItemDetailsModal";

const PathwayItemCard = ({ items, type = "skill", title = "Items" }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Group items by category (if category exists)
  // For certificates, don't group by category - show as flat list
  const groupedItems = items.reduce((acc, item) => {
    const category = type === "certificate" ? "certificates" : (item.category || "General");
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push({
      id: item.id || `${type}-${Math.random()}`,
      name: item.name,
      description: item.description,
      category: item.category,
      reason: item.reason,
      link: item.link,
      services: item.services,
      type: type
    });
    return acc;
  }, {});

  const handleItemClick = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedItem(null);
  };

  if (items.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">No {type}s data available at the moment.</p>
      </div>
    );
  }

  return (
    <>
      {/* Items by Category */}
      <div className="space-y-6">
        {Object.entries(groupedItems).map(([category, categoryItems]) => (
          <div key={category}>
            {/* Hide category heading for certificates */}
            {type !== "certificate" && (
              <h3 className="text-sm font-semibold text-gray-700 mb-3">{category}</h3>
            )}
            <div className="flex flex-wrap gap-2">
              {categoryItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleItemClick(item)}
                  className="px-3 py-1 bg-gray-100 text-black rounded-lg text-sm hover:bg-gray-200 transition-colors border border-gray-300 flex items-center gap-2"
                >
                  {/* Add icon for certificates */}
                  {type === "certificate" && (
                    <Award className="w-4 h-4 text-gray-600" />
                  )}
                  {item.name}
                </button>
              ))}
              {categoryItems.length === 0 && (
                <span className="text-sm text-gray-400 italic">No {type}s in this category yet.</span>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Item Details Modal */}
      <PathwayItemDetailsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        item={selectedItem}
      />
    </>
  );
};

export default PathwayItemCard;